import React from 'react';
import { Upload, Button, message, Image } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const ImageDisplayField = ({ 
  value,
  onChange,
  label, 
  uploadingImage, 
  uploadProps, 
  onUpload, 
  onRemove
}) => {
  const { t } = useTranslation();

  const handleDownload = async (imageUrl) => {
    try {
      // Fetch the image as blob
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      
      // Create blob URL
      const blobUrl = window.URL.createObjectURL(blob);
      
      // Extract filename from URL, removing query parameters
      const urlParts = imageUrl.split('/');
      const filenameWithParams = urlParts[urlParts.length - 1];
      const filename = filenameWithParams.split('?')[0] || 'image.jpg';
      
      // Create download link
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;
      link.style.display = 'none';
      
      // Add to DOM, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up blob URL
      window.URL.revokeObjectURL(blobUrl);
      
      message.success(t('Immagine scaricata con successo'));
    } catch (error) {
      console.error('Error downloading image:', error);
      message.error(t('Errore durante il download'));
    }
  };

  // Don't display local file paths
  const shouldDisplayImage = value && 
    !value.startsWith('C:\\fakepath\\') && 
    !value.startsWith('file://') && 
    (value.startsWith('http://') || value.startsWith('https://'));
  
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
      {shouldDisplayImage ? (
        <div style={{ flex: 1, textAlign: 'left' }}>
          <Image
            src={value}
            alt={label}
            style={{
              width: 70,
              height: 70,
              objectFit: 'cover',
              borderRadius: 6,
              cursor: 'pointer',
              border: '1px solid #d9d9d9'
            }}
            preview={false}
            onClick={() => handleDownload(value)}
          />
        </div>
      ) : (
        <div style={{ flex: 1, textAlign: 'center', color: '#999' }}>
          {uploadingImage ? t('Caricamento...') : t('Nessuna immagine caricata')}
        </div>
      )}
      
      <div style={{ flexShrink: 0 }}>
        {uploadingImage ? (
          <Button
            icon={<UploadOutlined />}
            loading={true}
            disabled={true}
          >
            {t('Caricamento...')}
          </Button>
        ) : (
          <Upload
            {...uploadProps}
            beforeUpload={(file) => {
              if (onUpload) {
                onUpload(file);
              }
              return false;
            }}
            showUploadList={false}
          >
            <Button
              icon={<UploadOutlined />}
              loading={uploadingImage}
              disabled={uploadingImage}
            >
              {t('Carica immagine')}
            </Button>
          </Upload>
        )}
      </div>
    </div>
  );
};

export default ImageDisplayField; 